import AiEnabledActionsIconSvg from 'assets/icons/ai-enabled-actions.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(AiEnabledActionsIconSvg, {
  displayName: 'AiExplanationIcon',
});
